export * from './text';
export * from './contact';
export * from './new_group';
export * from './location';
export * from './deleted';
export * from './photo';
export * from './upload';
export * from './video';



// WEBPACK FOOTER //
// ./src/components/middle/chat/msgs/index.js